import { createContext, ReactNode, useContext } from 'react';

import { useQuery } from '@tanstack/react-query';

import type { SeasonalThemeOption } from '@components/branding';

import { api } from 'api';

const SeasonalThemeContext = createContext<SeasonalThemeOption>('default');

export const SeasonalThemeProvider = ({ children }: { children: ReactNode }) => {
  const themeQuery = useQuery({
    queryKey: ['seasonalTheme'],
    queryFn: api.seasonalTheme.loadSeasonalTheme,
    staleTime: 1000 * 60 * 60,
  });
  if (themeQuery.isLoading) {
    return null;
  }
  return (
    <SeasonalThemeContext.Provider value={themeQuery.data || 'default'}>
      {children}
    </SeasonalThemeContext.Provider>
  );
};

export function useSeasonalTheme() {
  return useContext(SeasonalThemeContext);
}
